module.exports = __webpack_public_path__ + "assets/webgl/Frame_Painting_materialParams.1001.jpg.etc.4533b364.ktx";